import styled from 'styled-components'

import searchIcon from '../../assets/images/search-icon.png'

const Input = styled.input`
  width: 236px;
  background-color: var(--color-input-bg, #f1f4f7);
  padding: 9.5px 20px 9.5px 47px;
  color: var(--color-input-text, #4b5882);
  font-size: 14px;
  font-weight: bold;
  background-image: url(${searchIcon});
  background-size: 14px;
  background-repeat: no-repeat;
  background-position: 20px center;
  border: 2px solid transparent;
  border-radius: 4px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px rgba(151, 202, 111, 0.2);
  }

  ::-webkit-search-cancel-button {
    display: none;
  }

  &::placeholder {
    color: var(--color-text-secondary);
  }

  @media only screen and (max-width: 920px) {
    width: 100%;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

const Search = ({ searched, placeholder, handleChange, 'aria-label': ariaLabel, ...rest }) => {
  return (
    <Input
      type='search'
      onChange={handleChange}
      value={searched}
      placeholder={placeholder}
      aria-label={ariaLabel || placeholder}
      {...rest}
    />
  )
}

export default Search
